import { ExtensibilityServiceImplementation } from "./extensibility-service";
import sdServicesModule from "../sdServicesModule";

sdServicesModule.service("extensibilityService", ExtensibilityServiceImplementation);
